/* Jacquard collection: style chips show one group (or all); the feature card follows the shown group.
   Each chip has its own link, for ads: tapping one puts ?style=<edit> in the address bar (other parameters
   such as utm_* are kept), and opening /collections/<handle>?style=<edit> shows that style straight away.
   The plain collection link is unchanged. */
if (!customElements.get('jq-collection-grid')) {
  const PARAM = 'style';

  customElements.define(
    'jq-collection-grid',
    class extends HTMLElement {
      constructor() {
        super();
        this.addEventListener('click', (e) => {
          const chip = e.target.closest('[data-filter]');
          if (chip && this.contains(chip)) this.filter(chip.dataset.filter);
        });
      }

      connectedCallback() {
        const id = (new URL(window.location.href).searchParams.get(PARAM) || '').trim().toLowerCase();
        if (!id || id === 'all') return;
        const known = [...this.querySelectorAll('[data-filter]')].some((chip) => chip.dataset.filter === id);
        if (known) this.filter(id, { scroll: false, url: false });
      }

      filter(id, { scroll = true, url = true } = {}) {
        const all = id === 'all';
        this.querySelectorAll('[data-filter]').forEach((chip) => {
          chip.setAttribute('aria-pressed', String(chip.dataset.filter === id));
        });

        const groups = [...this.querySelectorAll('[data-group]')];
        groups.forEach((group) => {
          group.hidden = !all && group.dataset.group !== id;
          if (!group.hidden) this.animateIn(group);
        });

        const feature = this.querySelector('[data-feature]');
        const target = all
          ? groups[Math.min(Number(feature && feature.dataset.after) || 1, groups.length) - 1]
          : groups.find((group) => !group.hidden);
        if (feature && target) {
          target.after(feature);
          this.animateIn(feature);
        }

        if (url) this.setUrl(id);

        // Back to the top of the list if the visitor has scrolled past the chips.
        const anchor = this.querySelector('[data-anchor]');
        if (scroll && anchor) {
          const top = anchor.getBoundingClientRect().top + window.scrollY;
          if (window.scrollY > top) window.scrollTo(0, top);
        }
      }

      // Same page, new address (no reload, no extra Back step): ?style=<edit>, or none for "All".
      setUrl(id) {
        try {
          const url = new URL(window.location.href);
          if (id === 'all') url.searchParams.delete(PARAM);
          else url.searchParams.set(PARAM, id);
          window.history.replaceState(window.history.state, '', url);
        } catch (e) {
          // Old browsers: the filter still works, only the address stays the same.
        }
      }

      animateIn(el) {
        el.classList.remove('is-in');
        void el.offsetWidth;
        el.classList.add('is-in');
      }
    }
  );
}
